import React, {useState} from "react";
import {EXTRAS, PLANS} from "../../data/siteData";
import {onLight, stagger, TINT} from "../../utils";
import Icon from "../common/Icon";
import SectionIntro from "../common/SectionIntro";

const PricingSection = () => {
    const [openExtra, setOpenExtra] = useState(-1);

    return (
        <>
            <SectionIntro
                id="price"
                pill={{icon: 'euro', text: 'Pricing', bg: 'rgba(255,206,0,0.20)', color: '#6b5200'}}
                title={<>One rate. <span style={{color: '#d2660f'}}>Gear included.</span></>}
                titleStyle={{maxWidth: '24ch'}}
                lead="Prices are per canoe, not per person. Buoyancy aid, paddles and tracking device are always included in the price."
            />
            <section className="pb-container pb-section-body">
                <div className="pb-plans">
                    {PLANS.map((p, i) => {
                        // The most-booked plan inverts to navy; the rest stay white with a coloured chip.
                        const muted = p.dark ? '#a9bdd8' : '#5b6b85';
                        const accent = p.dark ? '#fff' : onLight(p.color);
                        const chip = p.dark ? 'rgba(255,255,255,0.16)' : TINT[p.color];
                        return (
                            <div key={p.term} className="pb-reveal pb-plan hover-lift-7" style={{
                                background: p.dark ? 'linear-gradient(150deg,#123c80,#0a2350)' : '#fff',
                                color: p.dark ? '#fff' : '#101f3a',
                                boxShadow: '0 22px 46px -30px ' + (p.dark ? 'rgba(12,38,84,0.85)' : 'rgba(12,38,84,0.55)'),
                                animationDelay: stagger(i)
                            }}>
                                {p.badge && <span className="pb-plan-badge">Most booked</span>}
                                <span className="pb-plan-icon" style={{background: chip, color: accent}}>
                                    <Icon name={p.icon} size={24}/>
                                </span>
                                <p className="pb-plan-term" style={{color: muted}}>{p.term}</p>
                                <p className="pb-plan-price">{p.price}</p>
                                <p className="pb-plan-note" style={{color: muted}}>{p.note}</p>
                                <div style={{display: 'flex', flexDirection: 'column', gap: 10}}>
                                    {p.items.map(item => (
                                        <div key={item} className="pb-plan-item">
                                            <span style={{
                                                background: p.dark ? 'rgba(255,255,255,0.2)' : TINT[p.color],
                                                color: accent
                                            }}><Icon name="check" size={13}/></span>
                                            <span>{item}</span>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        );
                    })}
                </div>

                <div className="pb-extras">
                    {EXTRAS.map((e, i) => {
                        const open = openExtra === i;
                        return (
                            <div key={e.title} className="pb-reveal pb-extra"
                                 style={{borderLeftColor: e.color, animationDelay: stagger(i, 70)}}>
                                <button onClick={() => setOpenExtra(open ? -1 : i)} aria-expanded={open}
                                        className="pb-extra-toggle">
                                    <span style={{display: 'block', minWidth: 0}}>
                                        <span className="pb-extra-title">{e.title}</span>
                                        <span className="pb-extra-body">{e.body}</span>
                                    </span>
                                    <span className="pb-chevron" style={{color: '#5b6b85', transform: open ? 'rotate(180deg)' : 'none'}}>
                                        <Icon name="chev" size={18}/>
                                    </span>
                                </button>
                                {open && <p className="pb-extra-more">{e.more}</p>}
                            </div>
                        );
                    })}
                </div>
            </section>
        </>
    );
};

export default PricingSection;
